// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__XdSkz","content":"error_content__PBVZV","error_text":"error_error_text__5+dGR","title":"error_title__Xm8nT"};